import { Request } from '../request';
import { IVideoTreatment, IAutoSaveInfo, IGetAutoSaveHistory, IAttachment, ITreatmentAddendum, TStandaloneLinkReq } from 'types/treatment';


export const getTreatmentDetailByAppointmentId = (id: number) =>
    Request.get({
        url: `/schedule-server/provider/treatment-plan/getDetailByAppointmentId?appointmentId=${id}`,
    });


export const submitVideoTreatment = (data: IVideoTreatment) => Request.post({
    url: `/schedule-server/provider/treatment-plan/saveOrSubmit`,
    params: data,
});


export const autoSaveInfo = (data: IAutoSaveInfo) => Request.post({
    url: '/schedule-server/provider/auto-save-history/auto-save',
    params: data,
});

export const getAutoSaveHistory = (data: IGetAutoSaveHistory) => Request.get({
    url: `/schedule-server/provider/auto-save-history/page?businessType=${data.businessType}&businessId=${data.businessId}&pageNum=${data.pageNum}&pageSize=${data.pageSize}&updateAt=${data.updateAt}`,
});

export const saveAttachment = (data: IAttachment[]) => Request.post({
    url: '/schedule-server/provider/text-visit-attachment/save-or-update',
    params: data,
});

export const getUpcomingVisitList = (clientId: number, upcomingVisitListSize: number) => Request.get({
    url: `/schedule-server/client/appointment/${clientId}/upcoming?upcomingVisitListSize=${upcomingVisitListSize}`,
});

// 获取治疗计划预约列表（分页查询）
export const getTreatmentPlanAppointmentList = (params: import('types/home').TTreatmentPlanAppointmentQueryReq) =>
    Request.post({
        url: '/schedule-server/provider/treatment-plan/appointment/pageList',
        params,
    });


export const getTreatmentAddendumList = (treatmentId: number) => Request.get({
    url: `/schedule-server/provider/treatment-plan/addendums?textVisitTreatmentId=${treatmentId}`,
});


export const submitTreatmentAddendum = (params: ITreatmentAddendum) => Request.post({
    url: '/schedule-server/provider/treatment-plan/addendums',
    params,
});

export const createStandaloneNote = (params: { clientId: number; specialty?: string }) => Request.post({
    url: '/schedule-server/provider/treatment-plan/standalone',
    params,
});

export const getStandaloneNoteDetail = (id: number) => Request.get({
    url: `/schedule-server/provider/treatment-plan/standalone/${id}`,
});

export const linkStandaloneNote = (id: number, params: TStandaloneLinkReq) => Request.post({
    url: `/schedule-server/provider/treatment-plan/standalone/${id}/link`,
    params,
});